module.exports = __webpack_public_path__ + "img/1-03.6748bb9f.png";